import { GRADIENT, GRADIENT2, COLORS } from "../../global/colors";

export const button_styles = {
  button: ({ theme }: any) => ({
    borderRadius: "6px",
    color: theme?.colorMode === "DARK" ? "#0a0e1a" : "var(--toggle-button-text)",
    border: `1px solid var(--button-bg)`,
    background: "var(--button-bg)",
    "&:hover": {
      backgroundColor: "var(--button-bg-hover)!important",
      textDecoration: "underline",
      cursor: "pointer",
    },
  }),
  secondary: {
    border: `1px solid var(--button-bg)`,
    color: "var(--button-bg)",
    borderRadius: "6px",
    "&:hover": {
      background: "#36d3991f",
      cursor: "pointer",
    },
  },
  empty: {
    borderRadius: "6px",
    background: "transparent",
    color: "var(--button-bg)",
    "&:hover": {
      background: "#36d3991f",
      cursor: "pointer",
    },
  },
  disabled: {
    borderRadius: "6px",
    cursor: "not-allowed",
    color: COLORS.$disabled,
    backgroundColor: COLORS.$disabledBackground,
  },
  ask_button: ({ askType }: any) => ({
    position: "absolute",
    zIndex: 800, //askType === "card" ? 9 : 0,
    top: askType === "card" ? "12px" : "-24px",
    right: askType === "card" ? "12px" : "6px",
    background: "var(--button-bg)",
    // border: "1px solid var(--brand-color)",
    color: "var(--toggle-button-text)",
    fontSize: "var(--fs12)",
    padding: "6px 6px",
    borderRadius: askType === "card" ? "6px" : "6px 6px 0 0", // askType === "card" ? "6px" :
    cursor: "pointer",
    "&:hover": {
      // background: "#36d3991f",
      color: "var(--toggle-button-text)",
    },
  }),
};
